
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_people/components/user_profile/templates/contact"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class='primary_wrapper'></div>\n<div class='social_wrapper'></div>\n";
},"useData":true});
    }).call(this);
  